import { render, staticRenderFns } from "./AccountingPromotions.vue?vue&type=template&id=59b22751"
import script from "./AccountingPromotions.vue?vue&type=script&lang=js"
export * from "./AccountingPromotions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports